import React from "react";
import "../../styles/footer/footer.css";
import Afrogotech from "../../assets/logo white.png";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const {t} = useTranslation();
  return (
    <div className="Footer--container">
      <div className="div1" >
        <img src={Afrogotech} alt="Aftogotech" />
        <p>
          {t('footer')}
        </p>
        <div className="footer-icons"></div>
      </div>
      <div className="div2" >
        <h1>Contact</h1>
        <p>
          <i class="fa-solid fa-location-dot"></i>{" "}
          <span>N° 306, 10 Rue Ghandi, Rabat</span>
        </p>
        <p>
          <i class="fa-solid fa-envelope"></i>{" "}
          <span>contact@afrogotech.ma</span>
        </p>
        <p>
          <i class="fa-solid fa-phone"></i> <span>+212 (0) 6 08 11 21 12</span>{" "}
        </p>
      </div>
      <div className="div3" >
        <h1>Social media</h1>
        <a href="https://www.facebook.com/afrogotech.ma">
          <i class="fa-brands fa-facebook"></i>
          afrogotech.ma
        </a>
        <a href="https://www.instagram.com/afrogotech/">
          <i class="fa-brands fa-instagram"></i>
          afrogotech
        </a>
        <a href="https://wa.me/0608112112">
          <i class="fa-brands fa-whatsapp"></i>
          +212 (0) 6 08 11 21 12
        </a>
      </div>
      <div className="div4" >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13227.751497312342!2d-6.8344971!3d34.0198056!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda76b8a82848cb1%3A0xd46d287ad1907383!2sAfrogotech!5e0!3m2!1sen!2sma!4v1697210085998!5m2!1sen!2sma"
          width="400"
          height="400"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Maps - Afrogotech Location"
        />
      </div>
      <br/><br/>
      <div className="copyright">
        <p>&copy; {(new Date().getFullYear())} Afrogotech. Developed By <span><a href="https://www.afrogotech.ma/">Afrogotech</a></span></p>
      </div>
    </div>
  );
}
